import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import * as usersService from "../../services/seller.services";
import * as userMgmtService from "../../services/usermgmt.services";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { formateDateWithMonth, formateDateWithMonthAdmin, removeSpecialCharacter, formatSecondsToHoursMinutes, handleServerValidations } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder, Modal } from "rsuite";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import AvatarImage from "../../../user/components/AvatarImage";

const APP_UPDATE_NOTIFICATION = {
  title: "New Version Available",
  body: "A new version of The Live Shop app has been published. Please download the latest update from the App Store / Play Store to continue enjoying new features and improvements.",
};

const ViewSeller = (props) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const showSendNotification = searchParams.get("notify") === "true";
  const [showdefault, setShowDefault] = useState({});
  const [sendingNotification, setSendingNotification] = useState(false);
  const [previewImage, setPreviewImage] = useState({
    open: false,
    url: "",
    title: "",
  });

  const handleImageClick = (url, title) => {
    if (!url) return;
    setPreviewImage({
      open: true,
      url,
      title: title || "Image Preview",
    });
  };

  const handleClosePreview = () => {
    setPreviewImage({
      open: false,
      url: "",
      title: "",
    });
  };
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("label_streamer_details"),
      url: "/admin/streamers/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    usersService
      .Details({ _id: params.id })
      .then((response) => {
        console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  const handleSendNotification = () => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: "Send app update notification to this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        setSendingNotification(true);
        userMgmtService
          .SendUserNotification({
            user_id: params.id,
            title: APP_UPDATE_NOTIFICATION.title,
            body: APP_UPDATE_NOTIFICATION.body,
          })
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("sendUserNotificationError", error);
            Swal.fire({
              icon: "error",
              text: "Failed to send notification",
              ...SWAL_SETTINGS,
            });
          })
          .finally(() => {
            setSendingNotification(false);
          });
      }
    });
  };

  return (
    <>
       <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  {t('label_streamer_details')}
                </h6>
              </div>
              {showdefault?.failed_verification_reason && !showdefault?.is_kyc_verified && (
                <div className="alert alert-danger mb-4 d-flex align-items-start gap-2" role="alert" style={{ borderRadius: "8px" }}>
                  <i className="ri-error-warning-fill fs-20 text-danger mt-1"></i>
                  <div>
                    <h6 className="alert-heading mb-1 font-weight-bold">Advertiser Request Rejected</h6>
                    <p className="mb-0"><strong>Reason for Rejection:</strong> {showdefault.failed_verification_reason}</p>
                  </div>
                </div>
              )}
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>Verification Status</th>
                          <td>
                            {showdefault?.is_kyc_verified || showdefault?.isAdvertiser ? (
                              <span className="badge badge-pill badge-success-light">Verified</span>
                            ) : showdefault?.failed_verification_reason && !showdefault?.is_kyc_verified ? (
                              <span className="badge badge-pill badge-danger-light">Rejected</span>
                            ) : (
                              <span className="badge badge-pill badge-warning-light">Pending</span>
                            )}
                          </td>
                        </tr>
                        {showdefault?.failed_verification_reason && !showdefault?.is_kyc_verified && (
                          <tr>
                            <th className="text-danger">Rejection Reason</th>
                            <td className="text-danger font-weight-bold">{showdefault.failed_verification_reason}</td>
                          </tr>
                        )}
                         <tr>
                          <th>{t("label_profile_picture")}</th>
                          <td>
                            <div
                              style={{
                                display: "inline-block",
                                cursor: showdefault?.profile_image ? "pointer" : "default",
                              }}
                              onClick={() => showdefault?.profile_image && handleImageClick(showdefault.profile_image, t("label_profile_picture"))}
                              title={showdefault?.profile_image ? "Click to preview image" : ""}
                            >
                              <AvatarImage
                                src={showdefault?.profile_image}
                                name={showdefault?.name}
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                  fontSize: "22px",
                                  border: "2px solid #e9edf4",
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_name")}</th>
                          <td className="text-capitalize">{showdefault?.name || "N/A"}</td>
                        </tr>
{/* 
                        <tr>
                          <th>{t("label_last_name")}</th>
                          <td>{showdefault?.last_name || "N/A"}</td>
                        </tr> */}

                        {/* <tr>
                          <th>{t("label_display_name")}</th>
                          <td>{showdefault?.display_name || "N/A"}</td>
                        </tr> */}

                        <tr>
                          <th>{t("label_email")}</th>
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              <span>{showdefault?.email || "N/A"}</span>
                              {showdefault?.email ? (
                                showdefault?.is_email_verified ? (
                                  <span className="badge bg-success-transparent text-success border border-success px-2 py-1" style={{ fontSize: "11px", borderRadius: "12px" }}>
                                    <i className="ri-checkbox-circle-fill me-1"></i> Verified
                                  </span>
                                ) : (
                                  <span className="badge bg-danger-transparent text-danger border border-danger px-2 py-1" style={{ fontSize: "11px", borderRadius: "12px" }}>
                                    <i className="ri-close-circle-fill me-1"></i> Unverified
                                  </span>
                                )
                              ) : null}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_phone_number")}</th>
                          <td>{showdefault?.phone_number || "N/A"}</td>
                        </tr>

                        {/* <tr>
                          <th>{t("label_whatsapp_number")}</th>
                          <td>{showdefault?.whatsapp_phone_number || "N/A"}</td>
                        </tr> */}

                        <tr>
                          <th>{t("label_gender")}</th>
                          <td>{showdefault?.kyc_gender || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_dob")}</th>
                          <td>
                            {showdefault?.kyc_dob
                              ? formateDateWithMonthAdmin(showdefault.kyc_dob)
                              : "N/A"}
                          </td>
                        </tr>

                           <tr>
                          <th>{t("label_used_hours")}</th>
                          <td>{formatSecondsToHoursMinutes(showdefault?.used_hours)}</td>
                        </tr>

                        <tr>
                          <th>{t("label_remaining_hours")}</th>
                          <td>{formatSecondsToHoursMinutes(showdefault?.remaining_hours)}</td>
                        </tr>

                     

                    
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault?.createdAt
                              ? formateDateWithMonthAdmin(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>Last Login IP</th>
                          <td>
                            {showdefault?.last_login_ip ? (
                              <span className="badge bg-primary-transparent text-primary" style={{ fontFamily: "monospace", fontSize: "12px", padding: "3px 8px" }}>
                                <i className="ri-computer-line me-1"></i>
                                {showdefault.last_login_ip}
                              </span>
                            ) : (
                              <span className="text-muted fst-italic">No login recorded</span>
                            )}
                          </td>
                        </tr>

                        <tr>
                          <th>Last Login Location</th>
                          <td>
                            {showdefault?.last_login_location ? (
                              <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                <i className="ri-map-pin-line text-secondary"></i>
                                <span>
                                  {typeof showdefault.last_login_location === "object"
                                    ? showdefault.last_login_location?.formatted || showdefault.last_login_location?.country || "Local / Private Network"
                                    : showdefault.last_login_location || "Local / Private Network"}
                                </span>
                              </span>
                            ) : (
                              <span className="text-muted fst-italic">No location recorded</span>
                            )}
                          </td>
                        </tr>

                        <tr>
                          <th>Last Login Date & Time</th>
                          <td>
                            {showdefault?.last_login_at ? (
                              <span>
                                <i className="ri-time-line me-1 text-primary"></i>
                                {formateDateWithMonthAdmin(showdefault.last_login_at)}
                              </span>
                            ) : (
                              <span className="text-muted fst-italic">Never logged in</span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {showdefault?.login_history && showdefault.login_history.length > 0 && (
                      <div className="mt-4">
                        <h6 className="main-content-label mb-2" style={{ fontSize: "13px" }}>
                          Recent Login Activity History
                        </h6>
                        <div className="table-responsive">
                          <table className="table table-bordered table-sm text-nowrap">
                            <thead className="thead-light">
                              <tr>
                                <th>#</th>
                                <th>IP Address</th>
                                <th>Location</th>
                                <th>Device / Client</th>
                                <th>Logged In At</th>
                              </tr>
                            </thead>
                            <tbody>
                              {showdefault.login_history.slice(-5).reverse().map((entry, idx) => (
                                <tr key={idx}>
                                  <td>{idx + 1}</td>
                                  <td>
                                    <span style={{ fontFamily: "monospace" }}>{entry.ip || "N/A"}</span>
                                  </td>
                                  <td>{entry.location || "Local Network"}</td>
                                  <td>{entry.device || "Unknown"}</td>
                                  <td>{entry.logged_at ? formateDateWithMonthAdmin(entry.logged_at) : "N/A"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
               <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              )}
            </div>


            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  {t('label_kyc_details')}
                </h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                      
                        {/* <tr>
                          <th>{t("label_business_registered")}</th>
                          <td>{showdefault?.isBusinessRegistered ? "True" : "False"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_kyc_registered")}</th>
                          <td>{showdefault?.isKycRegistered ? "True" : "False"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_kyc_verified")}</th>
                          <td clas>{showdefault?.is_kyc_verified ? "True" : "False"}</td>
                        </tr> */}

                        <tr>
                          <th>{t("label_kyc_name")}</th>
                          <td>{showdefault?.kyc_name || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_kyc_gender")}</th>
                          <td>{showdefault?.kyc_gender || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_kyc_dob")}</th>
                          <td>
                            {showdefault?.kyc_dob
                              ? formateDateWithMonthAdmin(showdefault.kyc_dob)
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_kyc_mobile")}</th>
                          <td>{showdefault?.kyc_mobile_number || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_kyc_doc_type")}</th>
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              <span>{showdefault?.kyc_doc_type ? showdefault.kyc_doc_type.toUpperCase() : "N/A"}</span>
                            
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_kyc_doc_number")}</th>
                          <td>{showdefault?.kyc_doc_number || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>
                            <div className="d-flex align-items-center gap-2">
                              <span>{t("label_kyc_doc_front")}</span>
                              {showdefault?.kyc_doc_type?.toLowerCase() === "pan" && (
                                <span className="badge bg-primary text-white" style={{ fontSize: "11px", padding: "4px 8px" }}>
                                  Business Proof
                                </span>
                              )}
                              {(showdefault?.kyc_doc_type?.toLowerCase() === "aadhar" || showdefault?.kyc_doc_type?.toLowerCase() === "aadhaar") && (
                                <span className="badge bg-success text-white" style={{ fontSize: "11px", padding: "4px 8px" }}>
                                  Address Proof
                                </span>
                              )}
                            </div>
                          </th>
                          <td>
                            {showdefault?.kyc_doc_front ? (
                              <div
                                style={{ display: "inline-block", cursor: "pointer" }}
                                onClick={() => handleImageClick(showdefault.kyc_doc_front, t("label_kyc_doc_front"))}
                                title="Click to preview image"
                              >
                                <img
                                  src={showdefault.kyc_doc_front}
                                  alt="front"
                                  width="120"
                                  className="img-thumbnail"
                                  style={{
                                    cursor: "pointer",
                                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                    borderRadius: "6px",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "scale(1.04)";
                                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.18)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "scale(1)";
                                    e.currentTarget.style.boxShadow = "none";
                                  }}
                                />
                                <div className="text-muted mt-1" style={{ fontSize: "11px" }}>
                                  <i className="fa fa-search-plus mr-1"></i> Click to preview
                                </div>
                              </div>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>

                        <tr>
                          <th>
                            <div className="d-flex align-items-center gap-2">
                              <span>{t("label_kyc_doc_back")}</span>
                              {showdefault?.kyc_doc_type?.toLowerCase() === "pan" && (
                                <span className="badge bg-primary text-white" style={{ fontSize: "11px", padding: "4px 8px" }}>
                                  Business Proof
                                </span>
                              )}
                              {(showdefault?.kyc_doc_type?.toLowerCase() === "aadhar" || showdefault?.kyc_doc_type?.toLowerCase() === "aadhaar") && (
                                <span className="badge bg-success text-white" style={{ fontSize: "11px", padding: "4px 8px" }}>
                                  Address Proof
                                </span>
                              )}
                            </div>
                          </th>
                          <td>
                            {showdefault?.kyc_doc_back ? (
                              <div
                                style={{ display: "inline-block", cursor: "pointer" }}
                                onClick={() => handleImageClick(showdefault.kyc_doc_back, t("label_kyc_doc_back"))}
                                title="Click to preview image"
                              >
                                <img
                                  src={showdefault.kyc_doc_back}
                                  alt="back"
                                  width="120"
                                  className="img-thumbnail"
                                  style={{
                                    cursor: "pointer",
                                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                    borderRadius: "6px",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "scale(1.04)";
                                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.18)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "scale(1)";
                                    e.currentTarget.style.boxShadow = "none";
                                  }}
                                />
                                <div className="text-muted mt-1" style={{ fontSize: "11px" }}>
                                  <i className="fa fa-search-plus mr-1"></i> Click to preview
                                </div>
                              </div>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_gst_number")}</th>
                          <td>{showdefault?.gst_number || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_store_name")}</th>
                          <td>{showdefault?.store_name || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_store_address")}</th>
                          <td>{showdefault?.store_location?.store_address || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("State")}</th>
                          <td>{showdefault?.state || showdefault?.store_location?.state || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_store_image")}</th>
                          <td>
                            {showdefault?.store_image ? (
                              <div
                                style={{ display: "inline-block", cursor: "pointer" }}
                                onClick={() => handleImageClick(showdefault.store_image, t("label_store_image"))}
                                title="Click to preview image"
                              >
                                <img
                                  src={showdefault.store_image}
                                  alt="store"
                                  width="120"
                                  className="img-thumbnail"
                                  style={{
                                    cursor: "pointer",
                                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                    borderRadius: "6px",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "scale(1.04)";
                                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.18)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "scale(1)";
                                    e.currentTarget.style.boxShadow = "none";
                                  }}
                                />
                                <div className="text-muted mt-1" style={{ fontSize: "11px" }}>
                                  <i className="fa fa-search-plus mr-1"></i> Click to preview
                                </div>
                              </div>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_total_hours")}</th>
                          <td>{formatSecondsToHoursMinutes(showdefault?.total_hours)}</td>
                        </tr>

                        <tr>
                          <th>{t("label_used_hours")}</th>
                          <td>{formatSecondsToHoursMinutes(showdefault?.used_hours)}</td>
                        </tr>

                        <tr>
                          <th>{t("label_remaining_hours")}</th>
                          <td>{formatSecondsToHoursMinutes(showdefault?.remaining_hours)}</td>
                        </tr>

                        <tr>
                          <th>{t("label_address")}</th>
                          <td>{showdefault?.address || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault?.createdAt
                              ? formateDateWithMonthAdmin(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_updated_at")}</th>
                          <td>
                            {showdefault?.updatedAt
                              ? formateDateWithMonthAdmin(showdefault.updatedAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7} />
              )}
            </div>
              <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                 Store Details
                </h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                      
                        {/* <tr>
                          <th>{t("label_business_registered")}</th>
                          <td>{showdefault?.isBusinessRegistered ? "True" : "False"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_kyc_registered")}</th>
                          <td>{showdefault?.isKycRegistered ? "True" : "False"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_kyc_verified")}</th>
                          <td clas>{showdefault?.is_kyc_verified ? "True" : "False"}</td>
                        </tr> */}

                      

                        <tr>
                          <th>{t("label_gst_number")}</th>
                          <td>{showdefault?.gst_number || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_store_name")}</th>
                          <td>{showdefault?.store_name || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_store_address")}</th>
                          <td>{showdefault?.store_location?.store_address || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_store_image")}</th>
                          <td>
                            {showdefault?.store_image ? (
                              <div
                                style={{ display: "inline-block", cursor: "pointer" }}
                                onClick={() => handleImageClick(showdefault.store_image, t("label_store_image"))}
                                title="Click to preview image"
                              >
                                <img
                                  src={showdefault.store_image}
                                  alt="store"
                                  width="120"
                                  className="img-thumbnail"
                                  style={{
                                    cursor: "pointer",
                                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                    borderRadius: "6px",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "scale(1.04)";
                                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.18)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "scale(1)";
                                    e.currentTarget.style.boxShadow = "none";
                                  }}
                                />
                                <div className="text-muted mt-1" style={{ fontSize: "11px" }}>
                                  <i className="fa fa-search-plus mr-1"></i> Click to preview
                                </div>
                              </div>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_total_hours")}</th>
                          <td>{formatSecondsToHoursMinutes(showdefault?.total_hours)}</td>
                        </tr>

                   
{/* 
                        <tr>
                          <th>{t("label_address")}</th>
                          <td>{showdefault?.address || "N/A"}</td>
                        </tr> */}

                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault?.createdAt
                              ? formateDateWithMonthAdmin(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_updated_at")}</th>
                          <td>
                            {showdefault?.updatedAt
                              ? formateDateWithMonthAdmin(showdefault.updatedAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7} />
              )}
            </div>

            {/* Rejection History Section */}
            <div className="card-body border-top">
              <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
                <h6 className="main-content-label mb-0 text-danger d-flex align-items-center gap-2">
                  <i className="fa fa-history"></i> Verification Rejection History
                </h6>
                {(() => {
                  const history = (showdefault?.rejection_history && Array.isArray(showdefault.rejection_history) && showdefault.rejection_history.length > 0)
                    ? showdefault.rejection_history
                    : (showdefault?.failed_verification_reason ? [{ reason: showdefault.failed_verification_reason, rejected_at: showdefault.updatedAt || showdefault.createdAt }] : []);
                  return (
                    <span className={`badge badge-pill ${history.length > 0 ? "badge-danger-light" : "badge-light"}`} style={{ fontSize: "12px", padding: "6px 12px" }}>
                      Total Rejections: {history.length} {history.length === 1 ? "time" : "times"}
                    </span>
                  );
                })()}
              </div>

              {(() => {
                const history = (showdefault?.rejection_history && Array.isArray(showdefault.rejection_history) && showdefault.rejection_history.length > 0)
                  ? showdefault.rejection_history
                  : (showdefault?.failed_verification_reason ? [{ reason: showdefault.failed_verification_reason, rejected_at: showdefault.updatedAt || showdefault.createdAt }] : []);

                return history.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-bordered table-hover">
                      <thead className="thead-light">
                        <tr>
                          <th style={{ width: "60px" }}>#</th>
                          <th>Reason for Rejection</th>
                          <th style={{ width: "280px" }}>Rejected Date & Time</th>
                          <th style={{ width: "120px" }}>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {history.map((item, index) => (
                          <tr key={index}>
                            <td className="font-weight-bold text-muted text-center">{index + 1}</td>
                            <td className="text-danger font-weight-semibold">{item.reason || "Requirements not met"}</td>
                            <td>{item.rejected_at ? formateDateWithMonthAdmin(item.rejected_at) : "N/A"}</td>
                            <td>
                              <span className="badge badge-pill badge-danger-light">Rejected</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="alert alert-light border text-muted mb-0 py-3">
                    <i className="fa fa-info-circle mr-1 text-primary"></i> No rejection records found for this profile.
                  </div>
                );
              })()}
            </div>

            <div className="mt-4 back-button d-flex align-items-center gap-2">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() => navigate(-1)}
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
              {showSendNotification && (
                <button
                  type="button"
                  className="btn btn-sm ripple btn-main-primary signbtn"
                  style={{ padding: "4px 12px", fontSize: "12px", whiteSpace: "nowrap" }}
                  onClick={handleSendNotification}
                  disabled={sendingNotification}
                >
                  {sendingNotification ? "Sending..." : "Send Notification"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Image Preview Modal */}
      <Modal
        open={previewImage.open}
        onClose={handleClosePreview}
        size="md"
        backdrop={true}
        keyboard={true}
      >
        <Modal.Header closeButton={false}>
          <div className="d-flex align-items-center justify-content-between w-100 pr-2">
            <Modal.Title className="font-weight-bold d-flex align-items-center gap-2 mb-0" style={{ fontSize: "16px" }}>
              <i className="fa fa-image text-primary mr-2"></i>
              <span>{previewImage.title || "Image Preview"}</span>
            </Modal.Title>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: "32px",
                height: "32px",
                minWidth: "32px",
                padding: 0,
                cursor: "pointer",
                border: "1px solid #ced4da",
                backgroundColor: "#fff",
                transition: "all 0.2s ease",
              }}
              onClick={handleClosePreview}
              title="Close Preview"
              aria-label="Close"
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#e9ecef";
                e.currentTarget.style.color = "#000";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#fff";
                e.currentTarget.style.color = "#333";
              }}
            >
              <i className="fa fa-times" style={{ fontSize: "14px" }}></i>
            </button>
          </div>
        </Modal.Header>
        <Modal.Body className="text-center p-3" style={{ backgroundColor: "#f8f9fa" }}>
          {previewImage.url ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "260px",
                maxHeight: "75vh",
                overflow: "auto",
              }}
            >
              <img
                src={previewImage.url}
                alt={previewImage.title || "Preview"}
                style={{
                  maxWidth: "100%",
                  maxHeight: "70vh",
                  objectFit: "contain",
                  borderRadius: "8px",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                  backgroundColor: "#fff",
                }}
              />
            </div>
          ) : (
            <div className="p-4 text-muted">No image available</div>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between align-items-center">
          <div>
            {previewImage.url && (
              <a
                href={previewImage.url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm btn-outline-primary"
              >
                <i className="fa fa-external-link mr-1"></i> Open Original
              </a>
            )}
          </div>
          <button
            type="button"
            className="btn btn-sm btn-secondary"
            onClick={handleClosePreview}
          >
            <i className="fa fa-times mr-1"></i> Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewSeller;
